// Load configuration from window.config (set in /public/config.js)
// Falls back to localhost for development if config is not available
declare global {
  interface Window {
    config?: {
      API_BASE_URL: string;
      ENVIRONMENT: string;
    };
  }
}

const getApiBaseUrl = (): string => {
  // Try to load from window.config first (runtime configuration)
  if (window.config?.API_BASE_URL && !window.config.API_BASE_URL.startsWith('%%')) {
    console.log('Using API_BASE_URL from window.config:', window.config.API_BASE_URL);
    return window.config.API_BASE_URL;
  }

  // Fallback to localhost for development
  console.log('Falling back to localhost:5050');
  return 'http://localhost:5050';
};

// Lazy evaluation - only compute when accessed
let cachedBaseUrl: string | null = null;

export const Urls = {
  get BaseApiUrl(): string {
    if (cachedBaseUrl === null) {
      cachedBaseUrl = getApiBaseUrl();
    }
    return cachedBaseUrl;
  }
};
